import {Component, inject, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {RouteMetaService} from './core/route-meta.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class App {
  protected readonly title = signal('connect-core');

  constructor() {
    inject(RouteMetaService).init();
  }
}
